import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { FEDERATED_PROFILES_TAGS, getFederatedUserProfile } from './endpoints/getFederatedUserProfile';

export const personalHealthApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getFederatedUserProfile: getFederatedUserProfile(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [FEDERATED_PROFILES_TAGS],
  });

export const { useGetFederatedUserProfileQuery } = personalHealthApi;
